import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
import { isImpersonating } from "@shared/services/impersonation";
import { isRestrictedRole } from "@retailer/services/preview_forbidden_flash";
import { get as getStoreValue } from "svelte/store";

const initialize = () => {
  if (isImpersonating() || isRestrictedRole(["supplier", "sales_rep"])) {
    console.log("Support chat is unavailable when previewing.");
    return;
  }

  //@ts-ignore
  const chat = window.embedded_svc;
  if (!chat) {
    const env = getEnvironmentConstants();
    const script = document.createElement("script");
    script.setAttribute("src", env.scriptUrl);
    script.onload = () => setSalesforceChatSettings(null);
    document.body.appendChild(script);
  } else {
    setSalesforceChatSettings("https://service.force.com");
  }

  window.addEventListener("click", flashClickHandler);
};

// Documentation here: https://developer.salesforce.com/docs/atlas.en-us.snapins_web_dev.meta/snapins_web_dev/snapins_web_prechat_details.htm
// This is a deprecated service but it was recommended as easier to implement.
const setSalesforceChatSettings = (gslbBaseURL: string) => {
  //@ts-ignore
  const chat = window.embedded_svc;
  if (!chat) {
    console.error("Salesforce chat not loaded");
    return;
  }
  const chatContext = window["C"]?.salesforceChatContext;
  let userId = getStoreValue(CurrentUserStore)?.id || "no_user";
  const env = getEnvironmentConstants();
  let botName = env.defaultBotName;
  let buttonId = env.defaultButtonId;

  if (chatContext === "distributor") {
    userId = "no_user";
    botName = env.distributorBotName;
    buttonId = env.distributorButtonId;
  }

  chat.settings.targetElement = document.body;
  chat.settings.displayHelpButton = true;
  chat.settings.language = "en";
  chat.settings.extraPrechatFormDetails = [
    {
      label: "Chat Session Provi Id",
      transcriptFields: ["Chat_Session_Provi_Id__c"],
      displayToAgent: true,
      value: userId,
    },
  ];
  chat.settings.defaultMinimizedText = "Chat with Support";
  chat.settings.disabledMinimizedText = "Chat Offline";
  chat.settings.enabledFeatures = ["LiveAgent"];
  chat.settings.entryFeature = "LiveAgent";
  chat.settings.showIcon = true;

  chat.init(env.salesforceUrl, env.supportUrl, gslbBaseURL, env.botId, botName, {
    baseLiveAgentContentURL: env.baseLiveAgentContentURL,
    deploymentId: env.deploymentId,
    buttonId: buttonId,
    baseLiveAgentURL: env.baseLiveAgentURL,
    eswLiveAgentDevName: botName,
    isOfflineSupportEnabled: false,
  });
};

const open = () => {
  //@ts-ignore
  const chat = window.embedded_svc;
  if (chat && chat.liveAgentAPI) {
    chat.liveAgentAPI.startChat();
  } else {
    const env = getEnvironmentConstants();
    const script = document.createElement("script");
    script.setAttribute("src", env.scriptUrl);
    script.onload = () => setSalesforceChatSettings(null);
    document.body.appendChild(script);
    //@ts-ignore
    window.embedded_svc.liveAgentAPI.startChat();
  }
};

const close = () => {
  //@ts-ignore
  const chat = window.embedded_svc;
  if (chat) {
    chat.liveAgentAPI.endChat();
  }
};

const hide = () => {
  //@ts-ignore
  const chat = window.embedded_svc;
  if (chat) {
    chat.hideHelpButton();
  }
};
const unhide = () => {
  //@ts-ignore
  const chat = window.embedded_svc;
  if (chat) {
    chat.showHelpButton();
  }
};

// Some flash messages contain a link to open the chat.
const flashClickHandler = event => {
  if (!event.target) return;

  if (event.target.dataset.openChat) {
    open();
  }
};

const getEnvironmentConstants = () => {
  //@ts-ignore
  const env = window.C?.env;

  if (env === "production") {
    return {
      scriptUrl: "https://proviforce.my.salesforce.com/embeddedservice/5.0/esw.min.js",
      salesforceUrl: "https://proviforce.my.salesforce.com",
      supportUrl: "https://support.provi.com/",
      botId: "00DDn000002GEPh",
      defaultBotName: "SupportBotGroup",
      distributorBotName: "DistributorSupplierBotGroup",
      baseLiveAgentContentURL: "https://c.la1-c1-ia6.salesforceliveagent.com/content",
      deploymentId: "572Dn000000dHAk",
      defaultButtonId: "573Dn000000dH6u",
      distributorButtonId: "573Dn000000dH6z",
      baseLiveAgentURL: "https://d.la1-c1-ia6.salesforceliveagent.com/chat",
    };
  } else {
    return {
      scriptUrl:
        "https://proviforce--aleysian.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js",
      salesforceUrl: "https://proviforce--uat.sandbox.my.salesforce.com",
      supportUrl: "https://proviforce--uat.sandbox.my.site.com/",
      botId: "00DDM000003fVIK",
      defaultBotName: "DemoBotUATGroup",
      distributorBotName: "DemoBotUATGroup",
      baseLiveAgentContentURL: "https://c.la1-c1cs-ia7.salesforceliveagent.com/content",
      deploymentId: "572DM000000GnoS",
      defaultButtonId: "573DM000000Gnxe",
      distributorButtonId: "573DM000000Gnxe",
      baseLiveAgentURL: "https://d.la1-c1cs-ia7.salesforceliveagent.com/chat",
    };
  }
};

export default { initialize, open, close, hide, unhide };
